export default {
  namespaced: true,
  state: {
    editSubscriptionId: null,
    trackingNumber: null,
    selectedCustomer: null,
    selectedCampaign: null,
    Subscription: {
      studentSub: false,
      startingDate: new Date().toISOString(),
      endDate: null,
      intervalType: null,
      recurringForever: false,
      recurringCount: null,
      isActive: true,
      intervalDays: null,
      intervalMonth: null,
      nextInvoiceDate: null,
      recurringDayOfMonth: null,
      DefaultDonationCategoryId: null,
      note: null,
      paymentMethodId: null,
    },
    SubscriptionDetails: [],
  },
  getters: {
    getEditSubscriptionId(state) {
      return state.editSubscriptionId
    },
    getSubscriptionDate(state) {
      return state.Subscription.date
    },
    getSubscriptionNote(state) {
      return state.Subscription.note
    },
    getTrackingNumber(state) {
      return state.trackingNumber
    },
    getSelectedCustomer(state) {
      return state.selectedCustomer
    },
    getSelectedCampaign(state) {
      return state.selectedCampaign
    },
    Subscription(state) {
      return state.Subscription
    },
    subscriptionTotal(state) {
      let total = 0;
      state.SubscriptionDetails.map(row => {
        // console.log('row SubscriptionDetails', row)
        if (!row.price) row.price = 0
        if (!row.qty) row.qty = 1

        if (!row.delete) {
          total += parseFloat(row.qty) * parseFloat(row.price);
        }
        
      });
      return total;
    },
    totalQty(state) {
      let total = 0;
      if (state.SubscriptionDetails) {
        state.SubscriptionDetails.map(row => {
          if (!row.delete) total += Math.abs(parseFloat(row.qty));
        });
      }
      return total;
    },
    SubscriptionDetails(state) {
      return state.SubscriptionDetails
    }
  },
  actions: {
    CopyPriceToAll({
      commit
    }, index) {
      commit('COPY_PRICE_TO_ALL', index)
    },
    SetEditSubscriptionId({commit}, payload) {
      commit('SET_EDIT_SUBSCRIPTION_ID', payload)
    },
    loadSubscription({commit}, payload) {
      commit('LOAD_SUBSCRIPTION', payload)
    },
    ResetSubscription({
      commit
    }) {
      commit('RESET_SUBSCRIPTION')
    },
    ResetSubscriptionDetail({
      commit
    }) {
      commit('RESET_SUBSCRIPTION_DETAIL')
    },
    SetSubscriptionDate({
      commit
    }, payload) {
      commit('SET_SUBSCRIPTION_DATE', payload)
    },
    SetSubscriptionDueDate({
      commit
    }, payload) {
      commit('SET_SUBSCRIPTION_DUE_DATE', payload)
    },
    SetSubscriptionNote({
      commit
    }, payload) {
      commit('SET_SUBSCRIPTION_NOTE', payload)
    },
    SetTrackingNumber({
      commit
    }, payload) {
      commit('SET_TRACKING_NUMBER', payload)
    },
  SetSelectedCustomer({
      commit
    }, payload) {
      commit('SET_SELECTED_CUSTOMER', payload)
    },
    SetSelectedCampaign({
      commit
    }, payload) {
      commit('SET_SELECTED_CAMPAIGN', payload)
    },
    DeleteSubscriptionDetailRow({
      commit
    }, payload) {
      commit('DELETE_SUBSCRIPTION_DETAIL_ROW', payload)
    },
    UnDeleteSubscriptionDetailRow({
      commit
    }, payload) {
      commit('UN_DELETE_SUBSCRIPTION_DETAIL_ROW', payload)
    },
    AddSubscriptionDetail({commit}, payload) {
      // console.log('AddSubscriptionDetail payload', payload)
      commit('ADD_SUBSCRIPTION_DETAIL', payload)
    }
  },
  mutations: {
    async COPY_PRICE_TO_ALL(state, index) {
      const sourcePriceRow = state.SubscriptionDetails[index]
      await Promise.all(
        state.SubscriptionDetails.map(row => {
          // console.log('change price', row.ProductId,  sourcePriceRow.ProductId)
          if (row.ProductId === sourcePriceRow.ProductId) {
            row.price = sourcePriceRow.price;
            row.total = sourcePriceRow.price * sourcePriceRow.qty;
          }
        })
      );
    },
    RESET_SUBSCRIPTION_DETAIL(state) {
      state.SubscriptionDetails = []
    },
    RESET_SUBSCRIPTION(state) {
      state.Subscription = {
        studentSub: false,
        startingDate: new Date().toISOString(),
        endDate: null,
        intervalType: null,
        recurringForever: false,
        recurringCount: null,
        isActive: true,
        intervalDays: null,
        intervalMonth: null,
        nextInvoiceDate: null,
        recurringDayOfMonth: null,
        note: null,
        paymentMethodId: null,
      }
      state.SubscriptionDetails = []
      state.trackingNumber = null
      state.selectedCustomer = null
    },
    LOAD_SUBSCRIPTION(state, payload) {
      state.Subscription.startingDate = payload.startingDate
      state.Subscription.id = payload.id
      state.Subscription.endDate = payload.endDate
      state.Subscription.intervalType = payload.intervalType
      state.Subscription.studentSub = payload.studentSub
      state.Subscription.recurringForever = payload.recurringForever
      state.Subscription.intervalMonth = payload.intervalMonth
      state.Subscription.intervalDays = payload.intervalDays
      state.Subscription.nextInvoiceDate = payload.nextInvoiceDate
      state.Subscription.paymentMethodId = payload.paymentMethodId
      state.Subscription.DefaultDonationCategoryId = payload.DefaultDonationCategoryId
      state.SubscriptionDetails = payload.SubscriptionDetails
      // state.selectedCustomer = payload.Customer
    },
    SET_EDIT_SUBSCRIPTION_ID(state, payload) {
      state.editSubscriptionId = payload
    },
    SET_SUBSCRIPTION_DATE(state, payload) {
      state.Subscription.date = payload
    },
    SET_SUBSCRIPTION_NOTE(state, payload) {
      state.Subscription.note = payload
    },
    SET_TRACKING_NUMBER(state, payload) {
      state.trackingNumber = payload
    },
    SET_SELECTED_CUSTOMER(state, payload) {
      state.selectedCustomer = payload
      // state.Subscription.DonorId = payload.id
    },
    SET_SELECTED_CAMPAIGN(state, payload) {
      state.selectedCampaign = payload
      state.Subscription.CampaignId = payload.id
    },
    DELETE_SUBSCRIPTION_DETAIL_ROW(state, payload) {
      const temp = state.SubscriptionDetails[payload]
      temp.delete = true
      state.SubscriptionDetails.splice(payload, 1, temp)
      // state.SubscriptionDetails.splice(payload, 1);
    },
    UN_DELETE_SUBSCRIPTION_DETAIL_ROW(state, payload) {
      const temp = state.SubscriptionDetails[payload]
      // console.log('temp', temp)
      delete temp.delete
      // temp.delete = true
      state.SubscriptionDetails.splice(payload, 1, temp)
      // state.SubscriptionDetails.splice(payload, 1);
    },
    ADD_SUBSCRIPTION_DETAIL(state, payload) {
      state.SubscriptionDetails.unshift(payload)
    }
  },
}